import { memo } from 'react';

import useExternalTokenListener from 'src/hooks/useExternalTokenListener.ts';

const ExternalTokenListener = () => {
  useExternalTokenListener();

  return null;
};

export default memo(ExternalTokenListener);
